/*
 * Copyright (c) 2020. American Express Company
 */

export const BW_PHANT_URL = templateUrl(process.env.REACT_APP_BW_PHANT_URL) || 'http://localhost:8080';
export const AUTH_TOKEN_KEY = process.env.REACT_APP_BW_AUTH_TOKEN_KEY || 'bw-auth-token';
// can be guid or snapshot alias
export const REFRESH_TOKEN_KEY = process.env.REACT_APP_BW_REFRESH_TOKEN_KEY || 'bw-refresh-token';
export const ENABLE_ADMIN = process.env.REACT_APP_ENABLE_ADMIN || false;
export const ALLOW_TEST_LOGIN = process.env.REACT_APP_ALLOW_TEST_LOGIN || false;
export const DISABLE_PLAID = false;
// default, need to set this to use it
export const MIXPANEL_KEY = process.env.REACT_APP_MIXPANEL_KEY;
export const MIXPANEL_HOST = templateUrl(process.env.REACT_APP_MIXPANEL_HOST);
export const APP_BASE_PATH = cleanBasePath(process.env.REACT_APP_BASE_PATH);
export const SPENDSMART_LANDING_PAGE_URL = process.env.REACT_APP_SPENDSMART_LANDING_PAGE_URL;
export const CRYPTO = process.env.REACT_APP_CRYPTO === 'true';
export const CUSTOM_ASSETS = process.env.REACT_APP_CUSTOM_ASSETS === 'true';

/**
 * Replace a templated url with actual values given the current environment
 *
 * @param url with identifiers like '#HOSTANME#'
 */
function templateUrl(url: string): string {
    // in some cases (webworkers), there is no window global
    const ctx: any = typeof window !== 'undefined' ? window : undefined;
    if (!ctx || !ctx.location || !ctx.location.hostname || !url) {
        // nothing there to swap in or it's empty, just return it
        return url;
    }
    // replace #HOSTNAME# with the window hostname for a given url
    return url.replace('#HOSTNAME#', ctx.location.hostname);
}

/**
 * Guarantee that basePath always ends without a slash
 * @param basePath raw basepath, falsy is like empty
 */
function cleanBasePath(basePath: string): string {
    if (!basePath) return '';
    basePath = basePath.trim();
    return basePath.endsWith('/') ? basePath.substring(0, basePath.length - 1) : basePath;
}
